<template>
  <div class="whs-filter-container">
    <div class="whs-filter-toggler whs-icon" @click="toggleFilter"></div>
    <div class="whs-filter" ref="filter">
      <div class="whs-form-control">
        <div class="whs-form-label">Сортировка</div>
        <select
          class="whs-form-select whs-form-select-sort"
          :class="{'open': sortIsOpen}"
          @change="handleSortChange"
          @click="hadleSortClick"
          @blur="handleSortBlur"
        >
          <option value="cheap">Сначала дешевые</option>
          <!-- <option value="popular">По популярности</option> -->
          <option value="expensive">Сначала дорогие</option>
          <option value="center">Ближе к центру</option>
          <option value="rated">С высокой оценкой</option>
        </select>
        <div class="whs-form-select-simulator whs-icon" :class="{'open': sortIsOpen}"></div>
      </div>
      <div class="whs-form-control">
        <div class="whs-form-label" v-if="hotelNameIsSet">Название отеля</div>
        <input
          type="text"
          class="whs-form-input"
          ref="hotelName"
          placeholder="Введите название отеля"
          @input="handleHotelNameInput"
        />
      </div>
      <div class="whs-form-control whs-form-control-stars">
        <div class="whs-form-label">Категория отеля</div>
        <div class="whs-form-stars">
          <div
            class="whs-form-stars-row"
            v-for="num in [5,4,3,2,1]"
            :key="num"
            :data-key="num"
            @click="handleStarsSelect"
          >
            <div class="whs-form-stars-checkbox whs-icon"></div>
            <div class="whs-form-star whs-icon" v-for="n in num" :key="n"></div>
            <div class="whs-small" style="padding-left: 8px" v-if="num === 1">или без звёзд</div>
          </div>
        </div>
      </div>
      <PriceRange
        :max="maxPrice"
        :minValue="options.priceStart"
        :maxValue="options.priceEnd"
        :setMin="setPriceStart"
        :setMax="setPriceEnd"
      />
      <div class="whs-form-control">
        <div class="whs-form-label">Питание</div>
        <div class="whs-form-checkboxset">
          <div
            class="whs-form-checkbox whs-icon"
            @click="handleMealSelect"
            data-key="nomeal"
          >Питание не включено</div>
          <div
            class="whs-form-checkbox whs-icon"
            @click="handleMealSelect"
            data-key="breakfast"
          >Затрак включен</div>
          <div
            class="whs-form-checkbox whs-icon"
            @click="handleMealSelect"
            data-key="halfBoard"
          >Завтрак + обед или ужин включены</div>
          <div
            class="whs-form-checkbox whs-icon"
            @click="handleMealSelect"
            data-key="fullBoard"
          >Завтрак, обед и ужин включены</div>
          <div
            class="whs-form-checkbox whs-icon"
            @click="handleMealSelect"
            data-key="allInclusive"
          >Всё включено</div>
      </div>
      </div>
    </div>
  </div>
</template>

<script>
import { invokeOnce } from '@/api';
import PriceRange from '@/components/PriceRange';
import { mapState } from 'vuex';

export default {
  name: 'ListFilter',
  components: {
    PriceRange
  },
  props: {
    callback: Function
  },
  data: function() {
    return {
      sortIsOpen: false,
      hotelNameIsSet: false,
      options: {
        hotelName: '',
        stars: [],
        priceStart: 0,
        priceEnd: 500000,
        meal: []
      }
    };
  },

  computed: {
    ...mapState('hotels', ['maxPrice']),
  },

  watch: {
    maxPrice(newMaxPrice) {
      this.options.priceEnd = newMaxPrice;
    }
  },
  methods: {
    setPriceStart(minValue) {
      this.options.priceStart = minValue;
      this.handlePriceChange();
    },
    setPriceEnd(maxValue) {
      this.options.priceEnd = maxValue;
      this.handlePriceChange();
    },
    toggleFilter() {
      this.$refs.filter.classList.toggle('open');
      if (this.$refs.filter.classList.contains('open')) {
        const closeFilter = e => {
          if (this.$refs.filter.contains(e.target)) return;

          this.$refs.filter.classList.remove('open');
          window.removeEventListener('click', closeFilter);
        };
        setTimeout(() => window.addEventListener('click', closeFilter), 0);
      }
    },

    handleSortChange(e) {
      e = e || window.event;
      const sort = e.target.value;
      this.$store.commit('hotels/sortHotels', sort);
      this.$store.commit('hotels/setPage', 0);
    },
    hadleSortClick() {
      this.sortIsOpen = !this.sortIsOpen;
    },
    handleSortBlur() {
      if (this.sortIsOpen) this.sortIsOpen = false;
    },
    handleHotelNameInput(e) {
      e = e || window.event;
      this.options.hotelName = e.target.value;
      invokeOnce(
        () => this.$store.commit('hotels/filterHotels', this.options),
        250
      );
      this.hotelNameIsSet = this.options.hotelName.length > 0;
    },
    handleStarsSelect(e) {
      e = e || window.event;
      const el = e.currentTarget;
      const n = parseInt(el.dataset.key);
      if (this.options.stars.includes(n))
        this.options.stars.splice(this.options.stars.indexOf(n), 1);
      else this.options.stars.push(n);
      el.classList.toggle('selected');
      this.$store.commit('hotels/filterHotels', this.options);
      this.$store.commit('hotels/setPage', 0);
    },
    handlePriceChange() {
      invokeOnce(
        () => this.$store.commit('hotels/filterHotels', this.options),
        1000
      );
    },
    handleMealSelect(e) {
      e = e || window.event;
      const el = e.currentTarget;
      const meal = el.dataset.key;
      if (this.options.meal.includes(meal))
        this.options.meal.splice(this.options.meal.indexOf(meal), 1);
      else this.options.meal.push(meal);
      el.classList.toggle('selected');
      this.$store.commit('hotels/filterHotels', this.options);
      this.$store.commit('hotels/setPage', 0);
    }
  }
};
</script>

<style>
@media (max-width: 1024px) {
  .whs-sidebar {
    display: flex;
  }
  .whs-hero {
    width: unset;
    flex: 4;
  }
}
.whs-form-label {
  padding: 4px 12px;
  position: absolute;
  font-size: 11px;
  color: var(--color-text-5);
  font-weight: 600;
  pointer-events: none;
}
</style>

<style scoped>
.whs-filter {
  margin-top: 24px;
  /* padding: 8px 6px; */
  /* background-color: var(--color-bg-dark); */
}
.whs-filter-toggler {
  padding: 12px;
  display: none;
  cursor: pointer;
}
.whs-filter-toggler:before {
  content: '\f085';
  font-size: 24px;
  color: var(--color-main);
}
@media (max-width: 1024px) {
  .whs-filter {
    display: none;
  }
  .whs-filter-container {
    display: flex;
    align-items: center;
  }
  .whs-filter-toggler {
    display: block;
  }
  .whs-filter.open {
    display: block;
    position: absolute;
    z-index: 2;
    background-color: var(--color-bg);
    right: 0;
    top: 100px;
    padding: 16px 4px;
    min-width: 300px;
    box-shadow: 0 0 1px var(--color-text-5), 0 0 8px var(--color-bg-dark);
  }
}
.whs-form-control {
  position: relative;
  width: 100%;
  max-width: 400px;
  padding: 8px;
}

.whs-form-select,
.whs-form-input {
  width: 100%;
  background-color: var(--color-bg);
  outline: none;
  line-height: 16px;
  padding: 20px 10px 8px;
  border: 1px solid var(--color-alt-5);
  font-family: 'Open Sans';
  font-weight: 700;
  font-size: 16px;
  appearance: none;
  cursor: pointer;
  transition: background-color 0.3s;
}
.whs-form-input {
  cursor: auto;
  background-color: #fff;
}
.whs-form-input::placeholder {
  color: var(--color-text);
  font-weight: 600;
  opacity: 0.75;
}
.whs-form-input:focus::placeholder {
  color: var(--color-alt);
}
.whs-form-select:focus {
  box-shadow: 0 0 1px var(--color-alt), 0 0 8px var(--color-bg-dark),
    1px 0 12px var(--color-bg);
}
.whs-form-select.open,
.whs-form-select:hover {
  background-color: #fff;
  transition: background-color 0.3s;
}
.whs-form-select-simulator {
  position: absolute;
  right: 9px;
  top: 9px;
  padding: 16px 12px 13px;
  cursor: pointer;
  transition: 0.3s;
}
.whs-form-select-simulator {
  pointer-events: none;
}
.whs-form-select-simulator:before {
  content: '\f00d';
  color: var(--color-alt);
  font-size: 18px;
}
.whs-form-select-simulator:before {
  content: '\f078';
  display: block;
}
.whs-form-select-simulator.open:before {
  transform: rotate(-180deg);
  transition: transform 0.3s;
}
/* .whs-form-control-stars {} */
.whs-form-stars,
.whs-form-checkboxset {
  border: 1px solid var(--color-alt-5);
  padding: 24px 8px 8px 8px;
}
.whs-form-stars:hover {
  background-color: #fff;
}
.whs-form-stars-row,
.whs-form-checkbox {
  display: flex;
  align-items: center;
  padding: 2px 0;
  user-select: none;
  cursor: pointer;
}
.whs-form-stars-checkbox,
.whs-form-star,
.whs-form-checkbox {
  display: flex;
  align-items: center;
  padding: 4px;
}
.whs-form-stars-checkbox,
.whs-form-checkbox {
  padding-right: 12px;
}
.whs-form-stars-checkbox:before,
.whs-form-checkbox:before {
  content: '\f0c8';
  font-weight: 300;
  font-size: 18px;
  color: var(--color-alt);
}
.whs-form-checkbox:before {
  margin-right: 12px;
}
.whs-form-stars-row.selected .whs-form-star:before,
.whs-form-stars-row.selected .whs-form-stars-checkbox:before,
.whs-form-checkbox.selected:before {
  color: var(--color-text);
}
.whs-form-stars-row.selected .whs-form-stars-checkbox:before,
.whs-form-checkbox.selected:before {
  content: '\f14a';
}
.whs-form-star:before {
  content: '\f005';
  font-size: 16px;
}
.whs-form-stars-row:not(.selected):hover .whs-form-star:before {
  color: var(--color-main);
}
.whs-form-stars-row:hover .whs-form-stars-checkbox:before,
.whs-form-checkbox:hover:before {
  content: '\f14a';
}
</style>